import * as Pinia from 'pinia'
import * as Vue from 'vue'
import * as VueI18n from 'vue-i18n'
import * as VueRouter from 'vue-router'
import * as VueQuery from '@tanstack/vue-query';

import type { Remote } from '@gohighlevel/ghl-module-federation-plugin'
import axios from 'axios'
import config from '../config/runtimeRemoteApps'
import { initFederation } from '@gohighlevel/ghl-module-federation-plugin'

const remoteApps: Remote[] = []
Object.keys(config).forEach(key => {
  remoteApps.push({
    name: key,
    alias: key,
    entry: config[key],
  })
})

initFederation({
  name: 'spm-ts-runtime-remote-apps',
  remotes: remoteApps,
  shared: {
    vue: {
      version: Vue.version,
      lib: () => Vue,
      shareConfig: { singleton: true, requiredVersion: '^3.5.13' },
    },
    'vue-i18n': {
      version: '11.1.1',
      lib: () => VueI18n,
      shareConfig: { singleton: true, requiredVersion: '^11.1.1' },
    },
    pinia: {
      version: '3.0.4',
      scope: 'default',
      lib: () => Pinia,
      shareConfig: {
        singleton: true,
        requiredVersion: '^3.0.0',
      },
    },
    axios: {
      version: '1.7.2',
      lib: () => axios,
      shareConfig: { singleton: true, requiredVersion: '^1.7.2' },
    },
    '@tanstack/vue-query': {
        version: '5.92.5',
        scope: 'default',
        lib: () => VueQuery,
        shareConfig: {
            singleton: true,
            requiredVersion: '^5.92.5',
        },
    },
    // Tree-shakeable libraries - no lib provider to maintain tree-shaking
    moment: {
      shareConfig: { singleton: true, requiredVersion: '^2.30.1' },
    },
    'moment-timezone': {
      shareConfig: { singleton: true, requiredVersion: '^0.5.43' },
    },
    'lodash-es': {
      shareConfig: { singleton: true, requiredVersion: '^4.17.21' },
    },
    lodash: {
      shareConfig: { singleton: true, requiredVersion: '^4.17.21' },
    },
    'vue-router': {
      version: '4.5.0',
      lib: () => VueRouter,
      shareConfig: { singleton: true, requiredVersion: '^4.5.0' },
    },
  },
})
